import { render, staticRenderFns } from "./PublicSchDetailPage.vue?vue&type=template&id=46a674b2&"
import script from "./PublicSchDetailPage.vue?vue&type=script&lang=js&"
export * from "./PublicSchDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports